import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Wrapper from "../../../common/Wrapper";
import Header from "../../../common/Header";
import NotificationBar from "../../../Parts/NotificationBar.jsx";
import SalesforceMapping from "../common/SalesforceMapping";
import SalesforceSettingComplete from "../common/SalesforceSettingComplete";
import SalesforceNotSupport from "../common/SalesforceNotSupport";
import SalesforceNotAuthorize from "../common/SalesforceNotAuthorize";
import SalesforceIntegrateExpire from "../common/SalesforceIntegrateExpire";
import SalesforceIntegrateLoading from "../common/SalesforceIntegrateLoading";
import SalesforceProgressBar from "../common/SalesforceProgressBar";
import ProgressControl from "../common/ProgressControl";
import TimelineStatusMappingTable from "./parts/TimelineStatusMappingTable";
import {
  salesforceTimelineStatusSettingStep,
  salesforceTimelineStatusSettingSteps,
  DialogType,
  SalesforceSettingDirectory,
} from "../../../../constants/ComponentTypes";
import { defaultSalesforceTimelineStatusExportMapping } from "../../../../constants/SalesforceMapping";
import { makeSalesforceExportMap } from "../../../../utils/utils";

const { Map } = require("immutable");

const styles = () => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "flex-start",
  },

  content: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    position: "relative",
    overflow: "scroll",
  },
});

/**
 * タイムラインのSalesforce連携設定の作成
 */
class SalesforceTimelineStatusSetup extends React.Component {
  state = {
    step: salesforceTimelineStatusSettingStep.MAPPING,
    showNotification: false,
    message: "",
    messageType: "success",
    mapping: Map(),
  };

  componentDidMount() {
    this.props.getUserInfo();
    this.props.getSalesforceDescribeTimelineStatusExport();
    this.props.getSalesforceConfig();

    // デフォルトの紐付け値にする
    this.setState({
      mapping: makeSalesforceExportMap(defaultSalesforceTimelineStatusExportMapping["Event"])
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.successMessage === this.props.successMessage && this.props.successMessage && this.props.successMessage !== "") {
      this.displayNotification(this.props.successMessage, "success");
    } else if (prevProps.errorMessage !== this.props.errorMessage && this.props.errorMessage && this.props.errorMessage !== '') {
      this.displayNotification(this.props.errorMessage, "error");
    } else if (prevProps.shortMessage !== this.props.shortMessage && this.props.shortMessage && this.props.shortMessage !== '') {
      this.displayNotification(this.props.shortMessage, "green");
    }

    // 設定済みの場合、設定画面にリダイレクト
    if (prevProps.isLoadingConfig && !this.props.isLoadingConfig) {
      if (this.props.timeline_status_export_mappings_flag) {
        this.props.replace(SalesforceSettingDirectory.TIMELINE_STATUS.setting_path);
      }
    }
  }

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  /*** handlers ***/
  goToStep = (step) => {
    this.setState({ step: step });
  };

  goToSalesforceSettingHome = () => {
    this.props.goTo("/setting/integrations/salesforce");
  }

  handleUpdateMapping = (mapping) => {
    this.setState({
      mapping: mapping,
    });
  };

  handlePrev = () => {
    const goStep = this.state.step - 1;

    if (goStep < 0) {
      this.props.goBack();
    } else {
      this.goToStep(goStep);
    }
  };

  handleNext = () => {
    const goStep = this.state.step + 1;
    this.goToStep(goStep);
  };

  /*** render functions ***/
  renderNotification = () => {
    if (this.state.showNotification) {
      return (
        <div
          style={{
            position: "fixed",
            zIndex: 10000,
            top: 10,
            width: "98%",
            left: "1%",
          }}
        >
          <NotificationBar
            message={this.state.message}
            type={this.state.messageType}
            open={this.state.showNotification}
            onHandleClose={() => {
              this.setState({ showNotification: false });
            }}
            autoClose={false}
            style={{
              width: this.state.messageType === "green" ? "fit-content" : "100%",
            }}
          ></NotificationBar>
        </div>
      );
    }
  };

  render() {
    const { classes, isLoadingFields, isLoadingConfig } = this.props;

    return (
      <Wrapper className={classes.root}>
        <Header
          title="Salesforce連携設定"
          secondaryTitle={SalesforceSettingDirectory.TIMELINE_STATUS.text + "連携設定"}
          type="dark"
          hasBackBtn={false}
          onTitleClicked={this.goToSalesforceSettingHome}
        />
        <div className={classes.content}>
          {(() => {
            if (this.props.user) {
              if (!this.props.user.salesforce_integration_flag) {
                return <SalesforceNotSupport />;
              } else if (!this.props.user.integrations.salesforce) {
                return <SalesforceNotAuthorize />;
              } else if (this.props.expiredAccessError) {
                return <SalesforceIntegrateExpire />;
              } else if (isLoadingFields || isLoadingConfig) {
                return <SalesforceIntegrateLoading />;
              } else {
                switch (this.state.step) {
                  case salesforceTimelineStatusSettingStep.MAPPING:
                  case salesforceTimelineStatusSettingStep.PREVIEW:
                    return (
                      <div>
                        <SalesforceProgressBar
                          step={this.state.step}
                          steps={salesforceTimelineStatusSettingSteps}
                          goToSalesforceSettingHome={this.goToSalesforceSettingHome}
                        >
                          <SalesforceMapping
                            step={this.state.step}
                            salesforceSettingStep={salesforceTimelineStatusSettingStep}
                            salesforceSettingDirectory={SalesforceSettingDirectory.TIMELINE_STATUS}
                            sobjectName={SalesforceSettingDirectory.TIMELINE_STATUS.text}
                          >
                            <TimelineStatusMappingTable
                              mapping={this.state.mapping}
                              enableEdit={this.state.step === salesforceTimelineStatusSettingStep.MAPPING ? true : false}
                              disabled={this.props.isConfiguring}
                              updateMapping={this.handleUpdateMapping}
                              eventFields={this.props.eventFields}
                            />
                          </SalesforceMapping>
                        </SalesforceProgressBar>
                        <ProgressControl
                          salesforceSettingDirectory={SalesforceSettingDirectory.TIMELINE_STATUS}
                          salesforceSettingStep={salesforceTimelineStatusSettingStep}
                          requiredFields={SalesforceSettingDirectory.TIMELINE_STATUS.required_fields.event}
                          step={this.state.step}
                          mapping={this.state.mapping}
                          isConfiguring={this.props.isConfiguring}
                          errorMessage={this.props.errorMessage}
                          postSalesforceExportMappingsTimelineStatus={this.props.postSalesforceExportMappingsTimelineStatus}
                          prev={this.handlePrev}
                          next={this.handleNext}
                        />
                      </div>
                    );
                  case salesforceTimelineStatusSettingStep.SETTING_COMPLETE:
                    return (
                      <SalesforceSettingComplete
                        type={SalesforceSettingDirectory.TIMELINE_STATUS.value}
                        dialogType={DialogType.CREATE}
                      />
                    );
                  default:
                    return null;
                }
              }
            }
          })()}
        </div>
        {this.renderNotification()}
      </Wrapper>
    );
  }
}

SalesforceTimelineStatusSetup.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  timeline_status_export_mappings_flag: PropTypes.bool,
  isLoadingFields: PropTypes.bool,
  isLoadingConfig: PropTypes.bool,
  isConfiguring: PropTypes.bool,
  eventFields: PropTypes.object,
  expiredAccessError: PropTypes.bool,
  goBack: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  replace: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  getSalesforceDescribeTimelineStatusExport: PropTypes.func.isRequired,
  getSalesforceConfig: PropTypes.func.isRequired,
  postSalesforceExportMappingsTimelineStatus: PropTypes.func.isRequired,
};

export default withStyles(styles)(SalesforceTimelineStatusSetup);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceTimelineStatusSetting/SalesforceTimelineStatusSetup.jsx